export default "__VITE_ASSET__B8hf$Y0E__ 100w";